import * as XLSX from "xlsx";

/**
 * Converts Excel clipboard HTML into a real .xlsx file. SheetJS parses the
 * Office HTML table directly, so an Excel paste becomes a native spreadsheet
 * (opens in Excel/Numbers, and the backend ingests xlsx like any upload).
 * Only imported by the main app (the chat widget keeps .html to stay light).
 * @param {string} htmlString - the text/html clipboard flavour
 * @param {string} baseName - file name without extension, e.g. "clipboard 1"
 * @returns {File}
 */
export const excelHtmlToXlsxFile = (htmlString, baseName) => {
  const workbook = XLSX.read(htmlString, { type: "string" });
  const data = XLSX.write(workbook, { type: "array", bookType: "xlsx" });
  return new File([data], `${baseName}.xlsx`, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
};
